export const analyzes = {
    date: (context?: string) => {
        const data = context?.split(":") || [];
        const cHours = Number(data?.[0]) || 0;
        const cMinutes = Number(data?.[1]) || 0;
        const cSeconds = Number(data?.[2]) || 0;

        return [cHours, cMinutes, cSeconds];
    },
};
